export default class ObjectService {
  get = (key:string) : any => {
    const name = `TSV_Session_${key}`;
    const data = localStorage.getItem(name);
    return data ? JSON.parse(data) : undefined;
  };
  
  set = (key: string, value: any) => {
    const name = `TSV_Session_${key}`;
    if (!value)
      localStorage.removeItem(name);
    else
      localStorage.setItem(name, JSON.stringify(value))
  }
  
  resetAll = () => {
    localStorage.clear();
  }
}